import { render } from "./DelegateApprovals.vue?vue&type=template&id=2d4d8c2f"
import script from "./DelegateApprovals.vue?vue&type=script&lang=js"
export * from "./DelegateApprovals.vue?vue&type=script&lang=js"

import "./DelegateApprovals.vue?vue&type=style&index=0&id=2d4d8c2f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__